<template>
  <div class="item-box">
    <b-row>
      <b-col :style="{ 'margin-left': 32 * deep + 'px' }">
        <div v-if="!isClose" @click="select">
          <span v-show="!isClose">
            <span v-if="!isExpand" @click="shrink" class="item-btn">
              <icon name="plus" class="fold-icon"></icon>
            </span>
            <span v-if="isExpand" class="item-btn">
              <icon name="minus" class="fold-icon"></icon>
            </span>
          </span>
          <span class="type-link">{{ item.name }}</span>
        </div>
        <b-form-checkbox
          :id="item.code"
          v-if="isClose"
          class="custom-control-inline select-checkbox"
          v-model="isAdd"
          @change="onchange($event)"
        >
          {{ item.name }}</b-form-checkbox
        >
      </b-col>
    </b-row>
    <m-loader size="before" :show="!hasLoad" />
    <m-geo-select-item
      v-if="hasLoad && isExpand & (values.length > 0)"
      :isClose="true"
      :geoType="geoType"
      :changeGeoType="changeGeoType"
      v-for="val in values"
      :item="val"
      :key="val.code"
      :deep="thisDeep"
    />
  </div>
</template>
  
<script>
export default {
  name: "mGeoSelectItem",
  props: {
    item: {
      type: Object,
    },
    deep: {
      type: Number,
      default: 0,
    },
    geoType: {
      type: Number,
      default: 1,
    },
    changeGeoType: {
      type: Number,
      default: 1,
    },
    isClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpand: false,
      thisDeep: 0,
      isAllAddTemple: false,
      values: [],
      hasLoad: true,
    };
  },
  computed: {
    listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    isAdd: {
      get() {
        return (
          _.filter(this.$store.getters["order/geoItems"], {
            GeoType: this.geoType,
            GeoKeyCode: this.item.GeoKeyCode,
          }).length > 0
        );
      },
      set(val) {
        if (val) {
        this.item.GeoType = this.geoType;
        this.$store.commit("order/addGeo", this.item);
      } else {
        console.log(this.item);
        this.$store.commit("order/deleteGeo", this.item);
      }
      },
    },
    isAllAdd: {
      get() {
        return this.isAllAddTemple;
      },
      set(val) {
        if (val) {
          if (this.values.length === 0) {
            this.expandSelectAll();
          } else {
            for (let item of this.values) {
              item.GeoType = this.geoType;
              this.$store.commit("order/addGeo", item);
            }
          }
        } else {
          for (let item of this.values) {
            this.$store.commit("order/deleteGeo", item);
          }
        }
        this.isAllAddTemple = val;
      },
    },
    datasource() {
      return this.$store.getters["config/datasource"];
    },
  },
  mounted() {
    this.thisDeep = this.deep + 1;
  },
  methods: {
    onchange(val) {
      console.log(1111);
      
    },
    select() {
      if (this.isExpand) {
        this.isExpand = false;
      } else if (!this.isExpand) {
        this.isExpand = true;
        if (this.values.length === 0) {
          this.expand();
        }
      }
    },
    shrink() {
      this.isExpand = false;
    },
    expand() {
      if (this.isClose || this.item.val) {
        return;
      }
      this.hasLoad = false;
      if (this.geoType === 3) {
        this.$http
          .post("PlaceOrder.aspx/GetCountiesByState", {
            statecode: this.item.code,
          })
          .then((resp) => {
            let data = resp.body.d.DataSource;
            for (let item of data) {
              item.GeoKeyCode = item.CountyCode;
              item.GeoKeyDesc = item.CountyName + "(" + this.item.code + ")";
              item.text = item.CountyName;
              item.name = item.CountyName;
              item.ConutryCode = "US";
              if (this.datasource.isInfoUSACounty) {
                item.CountyFips = `${item.CountyName}_${this.item.code}`;
              }
            }
            this.values = data;
            this.hasLoad = true;
          });
      } else if (this.geoType === 10) {
        this.$http
          .post("PlaceOrder.aspx/SearchAreas", {
            state: this.item.code,
            listType: this.listType,
          })
          .then((resp) => {
            let data = resp.body.d.DataSource;
            for (let item of data) {
              item.GeoKeyCode = item.Code;
              item.GeoKeyDesc = `${item.DisplayName}(${this.item.code})`;
              item.text = item.DisplayName;
              item.name = item.DisplayName;
            }
            this.values = data;
            this.hasLoad = true;
          });
      } else if (this.geoType === 22) {
        this.$http
          .post("PlaceOrder.aspx/GetDistrictsByState", {
            statecode: this.item.code,
          })
          .then((resp) => {
            let data = resp.body.d.DataSource;
            for (let item of data) {
              item.GeoKeyCode = item.Code;
              item.CityName = item.Name;
              item.GeoKeyDesc = `${item.Name}(${this.item.code})`;
              item.text = item.Name;
              item.name = item.Name;
            }
            this.values = data;
            this.hasLoad = true;
          });
      } else if (this.geoType === 4) {
        this.$http
          .post("PlaceOrder.aspx/GetCitiesByState", {
            statecode: this.item.code,
          })
          .then(
            (resp) => {
              let data = resp.body.d.DataSource;
              for (let item of data) {
                item.GeoKeyCode = item.CityName + ":" + this.item.code;
                item.GeoKeyDesc = `${item.CityName}(${this.item.code})`;
                item.text = item.CityName;
                item.name = item.CityName;
              }
              this.values = data;
              this.hasLoad = true;
            },
            (resp) => {}
          );
      }
    },
    expandSelectAll() {
      let that = this;
      this.$store.dispatch("order/changeGeoType", this.changeGeoType);
      if (this.geoType === 3) {
        this.$http
          .post("PlaceOrder.aspx/GetCountiesByState", {
            statecode: this.item.code,
          })
          .then((resp) => {
            let data = resp.body.d.DataSource;
            for (let item of data) {
              item.GeoKeyCode = item.CountyCode;
              item.GeoKeyDesc = item.CountyName + "(" + this.item.code + ")";
              item.text = item.CountyName;
              item.name = item.CountyName;
              item.ConutryCode = "US";
              if (this.datasource.isInfoUSACounty) {
                item.CountyFips = `${item.CountyName}_${this.item.code}`;
              }
              item.GeoType = that.geoType;
              that.$store.commit("order/addGeo", item);
            }
            this.values = data;
          });
      } else if (this.geoType === 10) {
        this.$http
          .post("PlaceOrder.aspx/SearchAreas", {
            state: this.item.code,
            listType: this.listType,
          })
          .then((resp) => {
            let data = resp.body.d.DataSource;
            for (let item of data) {
              item.GeoKeyCode = item.Code;
              item.GeoKeyDesc = `${item.DisplayName}(${this.item.code})`;
              item.text = item.DisplayName;
              item.name = item.DisplayName;
              item.GeoType = that.geoType;
              that.$store.commit("order/addGeo", item);
            }
            this.values = data;
          });
      } else if (this.geoType === 22) {
        this.$http
          .post("PlaceOrder.aspx/GetDistrictsByState", {
            statecode: this.item.code,
          })
          .then((resp) => {
            let data = resp.body.d.DataSource;
            for (let item of data) {
              item.GeoKeyCode = item.Code;
              item.CityName = item.Name;
              item.GeoKeyDesc = `${item.Name}(${this.item.code})`;
              item.text = item.Name;
              item.name = item.Name;
              item.GeoType = that.geoType;
              that.$store.commit("order/addGeo", item);
            }
            this.values = data;
          });
      } else if (this.geoType === 4) {
        this.$http
          .post("PlaceOrder.aspx/GetCitiesByState", {
            statecode: this.item.code,
          })
          .then(
            (resp) => {
              let data = resp.body.d.DataSource;
              for (let item of data) {
                item.GeoKeyCode = item.CityName + ":" + this.item.code;
                item.GeoKeyDesc = `${item.CityName}(${this.item.code})`;
                item.text = item.CityName;
                item.name = item.CityName;
                item.GeoType = that.geoType;
                that.$store.commit("order/addGeo", item);
              }
              this.values = data;
            },
            (resp) => {}
          );
      }
    },
  },
};
</script>
  
<style scoped lang="scss">
.all-hosehodls {
  margin-top: 16px;
}

.item-box {
  /*margin-left: 16px;*/
  position: relative;
  display: block;
}

.icon-close {
  margin-left: 32px;
  margin-right: 16px;
}

.item {
  margin-bottom: 16px;
}

.btns {
  margin-left: 8px;
  padding-top: 4px;
}

.btns-block {
  display: inline-block;
  width: 80px;
}

.custom-checkbox {
  min-height: 1rem;
}

.fold-icon {
  vertical-align: sub;
}

.custom-control-input:checked ~ .custom-control-label::before {
  border-color: green !important;
  background-color: green !important;
}

.lable-name {
  margin-bottom: 0px;
}
</style>
  


// WEBPACK FOOTER //
// src/Components/geo/MGeoSelectItem.vue